// @ts-nocheck
if (!customElements.get('accordion-group')) {
customElements.define(
    'accordion-group',
    class AccordionGroup extends HTMLElement {
    constructor() {
        super();

        this.container = this;
        this.header = this.querySelector('.information-accordion-header');         
        
        this.header.addEventListener('click', () => {      
        const isOpen = this.container.getAttribute('data-is-open') === 'true';
        this.container.setAttribute('data-is-open', String(!isOpen));
        });
    }
    }
);
}

if (!customElements.get('sidebar-group')) {
    customElements.define(
      'sidebar-group',
      class SidebarGroup extends HTMLElement {
        constructor() {
          super();

          this.container = this;
          this.header = this.querySelector('.sidebar-group-header');  
          this.group = this.container.getAttribute('data-group')       
          
          this.header.addEventListener('click', (e) => {  
            const activeGroup = document.querySelector('.sidebar-group[data-is-open="true"]');
            if(activeGroup){
              const activeGroupHeader = activeGroup.querySelector('.sidebar-group-header');
              if(e.currentTarget == activeGroupHeader) return;
            }

            //prev
            document.querySelectorAll('.sidebar-group[data-is-open="true"], .information-group-wrapper[data-is-open="true"]').forEach(item => {
              item.setAttribute('data-is-open', "false")
            })

            //new
            this.container.setAttribute('data-is-open', "true");
            const informationGroup = document.querySelector(`.information-group-wrapper[data-group="${this.group}"]`);
            informationGroup.setAttribute('data-is-open', "true");
            document.querySelector('groups-select').setValue(this.group);
          });
        }
      }
    );
  }

  if (!customElements.get('groups-select')) {
    customElements.define(
      'groups-select',
      class GroupsSelect extends HTMLElement {
        constructor() {
          super();

          this.container = this;
          this.ignoreNextChange = false;
          this.wasAtTop = false;
          this.wasAtBottom = false;

          const select = this.container.querySelector('select');

          select.addEventListener('change', (event) => {
            if (this.ignoreNextChange) {
              this.ignoreNextChange = false; // reset flag
              return;
            }

            const selectedValue = event.target.value;

            // prev
            document.querySelectorAll('.sidebar-group[data-is-open="true"], .information-group-wrapper[data-is-open="true"]').forEach(item => {
              item.setAttribute('data-is-open', "false");
            });

            // new
            document.querySelectorAll(`.sidebar-group[data-group="${selectedValue}"], .information-group-wrapper[data-group="${selectedValue}"]`).forEach(item => {
              item.setAttribute('data-is-open', "true");
            });
          });

          // Optional helper method to change value programmatically
          this.setValue = (value) => {
            this.ignoreNextChange = true;
            select.value = value;
            select.dispatchEvent(new Event('change'));
          };

          this.setStickySidebar();

          window.addEventListener('scroll', this.checkPosition.bind(this));
        }

        checkPosition() {
          if(window.matchMedia("(max-width: 1023px)").matches) return;

          const parent = document.querySelector('.information-main-grid');
          const sticky = document.querySelector('.information-sidebar');

          const parentRect = parent.getBoundingClientRect();
          const stickyRect = sticky.getBoundingClientRect();

          const stickyTopRelative = stickyRect.top - parentRect.top;
          const stickyBottomRelative = stickyRect.bottom - parentRect.bottom;

          // Check if sticky hit the top of parent
          if (stickyTopRelative <= 0) {
            if (!this.wasAtTop) {
              this.wasAtTop = true;
              this.setStickySidebar();
            }
          } else {
            this.wasAtTop = false;
          }

          // Check if sticky hit the bottom of parent
          if (stickyBottomRelative >= 0) {
            if (!this.wasAtBottom) {
              this.wasAtBottom = true;
              this.setStickySidebar();
            }
          } else {
            this.wasAtBottom = false;
          }
        }

        setStickySidebar(){
          const sidebar = document.querySelector('.information-sidebar');
          const header = document.querySelector('.custom-header .header-inner');
          const paddingTop = parseInt(sidebar.getAttribute('data-padding-top')) || 0;

          const totalHeight = window.innerHeight - (header.offsetHeight + 28 + paddingTop);

          if(sidebar.offsetHeight < totalHeight){
            sidebar.style.top = `${header.offsetHeight + 28 + paddingTop}px`;
          }else{             
            if(this.wasAtTop){
              sidebar.style.top = `${window.innerHeight - sidebar.offsetHeight - paddingTop}px`;
            }else{
              sidebar.style.top = `${header.offsetHeight + 28 + paddingTop}px`;
            }
          }
        }
      }
    );
  }

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sidebar-group-inner-link').forEach(link => {
        link.addEventListener('click', (e) => {
        const accordion = document.querySelector(`#${link.getAttribute('data-handle-id')} .accordion-group`);
        accordion.setAttribute('data-is-open', 'true');
        })
    })
})